import React from 'react';
import { Modal } from 'react-bootstrap';
import { SlidersHorizontal, X } from 'lucide-react';
import './FilterModal.scss';

/**
 * FilterModal — Reusable mobile-first filter modal.
 * 
 * Props:
 *   show       — boolean, controls modal visibility
 *   onHide     — callback to close modal
 *   title      — modal title (default: "Filters")
 *   children   — filter form content (selects, inputs, etc.)
 *   onApply    — callback when "Apply" is clicked (optional, closes modal by default)
 *   onReset    — callback when "Reset" is clicked (optional)
 *   activeCount — number of active filters (shown as badge on trigger button)
 */
const FilterModal = ({ show, onHide, title = 'Filters', children, onApply, onReset }) => {
  const handleApply = () => {
    onApply?.();
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered className="filter-modal" size="sm">
      <Modal.Header className="filter-modal__header">
        <Modal.Title className="filter-modal__title">
          <SlidersHorizontal size={18} />
          {title}
        </Modal.Title>
        <button type="button" className="filter-modal__close" onClick={onHide} aria-label="Close">
          <X size={18} />
        </button>
      </Modal.Header>
      <Modal.Body className="filter-modal__body">
        {children}
      </Modal.Body>
      <Modal.Footer className="filter-modal__footer">
        {onReset && (
          <button type="button" className="btn filter-modal__reset-btn" onClick={onReset}>
            Reset
          </button>
        )}
        <button type="button" className="btn btn-primary filter-modal__apply-btn" onClick={handleApply}>
          Apply Filters
        </button>
      </Modal.Footer>
    </Modal>
  );
};

/**
 * FilterGroup — Label + control wrapper used inside FilterModal.
 */
const FilterGroup = ({ label, children }) => (
  <div className="filter-modal__group">
    {label && <label className="filter-modal__label">{label}</label>}
    {children}
  </div>
);

export { FilterModal, FilterGroup };
export default FilterModal;
